export class FaturasModel {
  id_fatura: number;
  id_cliente: number = null;
  id_unidade: number = null;
  id_usuario: number;
  id_moeda: number = null;
  id_banco: number = null;
  data: string;
  data_pagamento: string;
  data_vencimento: string;
  valor_total: number = 0.00;
  forma_pagamento: string = null;
  status: string;
  numero: string;
  nota_fiscal: number = null;
  cliente: any;
  unidade: any;
  moeda: any;
  valor_fixo: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/faturas/faturas.model.ts